// extracted by mini-css-extract-plugin
export var resizer = "_dv-0";